import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import HeroSliderEight from "../../wrappers/hero-slider/HeroSliderEight";
import TabProduct from "../../wrappers/product/TabProduct";
import NewsletterTwo from "../../wrappers/newsletter/NewsletterTwo";
import AboutUs from '../other/About';
import Guia from '../other/Guia';
import TestimonialOne from "../../wrappers/testimonial/TestimonialOne";
import InstagramView from "../../wrappers/product/InstagramView";
const HomeFashion = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>Paseos en familia</title>
        <meta
          name="description"
          content="Fashion home of flone react minimalist eCommerce template."
        />
      </MetaTags>
      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-1"
      >
        {/* hero slider */}
        <HeroSliderEight />

        {/* featured icon */}
        <TabProduct spaceTopClass="pt-60" category="destacado" />

        <AboutUs />

        {/* tab product */}
        <NewsletterTwo spaceBottomClass="pb-120" spaceTopClass="pt-80"/>
        <Guia />
        <TestimonialOne  spaceTopClass="pt-120" />
        <InstagramView spaceBottomClass="pb-90" spaceTopClass="pt-80" />
      </LayoutOne>
    </Fragment>
  );
};

export default HomeFashion;
